import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';

const SignIn = ({ onSignIn, onRegisterClick }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
      onSignIn(data.user);
      navigate('/'); // Navigate to landing page after successful sign-in
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAnonymousSignIn = async () => {
    setError('');
    setIsLoading(true);
    try {
      const { data, error } = await supabase.auth.signUp({
        email: `${crypto.randomUUID()}@anonymous.user`,
        password: crypto.randomUUID(),
      });
      
      if (error) throw error;
      onSignIn(data.user);
      navigate('/'); // Navigate to landing page after successful sign-in
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
        <div className="px-8 pt-8 pb-6">
          <div className="flex items-center justify-center mb-8">
            <img 
              src="/logo.png" 
              alt="Aviation Synergy Logo" 
              className="h-12 w-auto mr-4"
            />
            <h2 className="text-2xl font-bold bg-gradient-to-r from-[#103558] to-[#0D2A45] bg-clip-text text-transparent">
              Max_Comply
            </h2>
          </div>
          {error && (
            <div className="mb-6 p-3 rounded-lg bg-red-50 border border-red-100">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}
          <form onSubmit={handleSignIn} className="space-y-5">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                Email address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full px-4 py-2.5 rounded-full border border-gray-300 focus:ring-2 focus:ring-[#103558]/20 focus:border-[#103558] transition-colors"
                placeholder="Enter your email"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1.5">
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="w-full px-4 py-2.5 rounded-full border border-gray-300 focus:ring-2 focus:ring-[#103558]/20 focus:border-[#103558] transition-colors"
                placeholder="Enter your password"
              />
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="
                w-full px-6 py-2.5 rounded-full
                bg-gradient-to-r from-[#103558] to-[#0D2A45]
                text-white text-sm font-medium
                transition-all duration-200
                hover:shadow-lg hover:-translate-y-0.5
                focus:outline-none focus:ring-2 focus:ring-[#103558]/50
                disabled:opacity-50 disabled:cursor-not-allowed
              "
            >
              {isLoading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <div className="px-8 py-6 bg-gray-50 border-t border-gray-100">
          <div className="flex items-center justify-between mb-6">
            <div className="border-t flex-grow border-gray-200"></div>
            <span className="px-4 text-sm text-gray-500">or continue with</span>
            <div className="border-t flex-grow border-gray-200"></div>
          </div>

          <button
            onClick={handleAnonymousSignIn}
            disabled={isLoading}
            className="
              w-full px-6 py-2.5 rounded-full
              bg-white border border-gray-300
              text-gray-700 text-sm font-medium
              transition-all duration-200
              hover:bg-gray-50 hover:shadow hover:-translate-y-0.5
              focus:outline-none focus:ring-2 focus:ring-gray-200
              disabled:opacity-50 disabled:cursor-not-allowed
            "
          >
            {isLoading ? 'Processing...' : 'Continue as Guest'}
          </button>

          <p className="mt-6 text-center text-sm text-gray-600">
            Don't have an account?{' '}
            <button
              onClick={onRegisterClick}
              className="font-medium text-[#103558] hover:text-[#0D2A45] transition-colors"
            >
              Sign Up
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
